import { useState, useRef } from 'react';

const CustomSorter = ({ items, setItems, renderItem, keyExtractor }) => {
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const dragItem = useRef(null);
  const dragNode = useRef(null);

  const handleDragStart = (e, index) => {
    dragItem.current = index;
    dragNode.current = e.target;
    dragNode.current.addEventListener('dragend', handleDragEnd);
    setDraggedIndex(index);
    
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragEnter = (e, index) => {
    e.preventDefault();
    if (dragItem.current !== index) {
      setDragOverIndex(index);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    const dragIndex = dragItem.current;

    if (dragIndex === dropIndex) {
      setDragOverIndex(null);
      return;
    }

    const newItems = [...items];
    const draggedItem = newItems[dragIndex];
    
    newItems.splice(dragIndex, 1);
    newItems.splice(dropIndex, 0, draggedItem);
    
    setItems(newItems);
    setDragOverIndex(null);
  };

  const handleDragEnd = () => {
    dragItem.current = null;
    dragNode.current = null;
    setDraggedIndex(null);
    setDragOverIndex(null);
  };

  return (
    <div className="w-full">
      {items.map((item, index) => {
        const isDragging = draggedIndex === index;
        const isDraggedOver = dragOverIndex === index;
        
        return (
          <div
            key={keyExtractor(item)}
            draggable
            onDragStart={(e) => handleDragStart(e, index)}
            onDragEnter={(e) => handleDragEnter(e, index)}
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, index)}
            className={`
              transition-all duration-200
              ${isDragging ? 'opacity-50' : 'opacity-100'}
              ${isDraggedOver ? 'border-t-2 border-blue-500' : ''}
            `}
          >
            {renderItem(item, index)}
          </div>
        );
      })}
    </div>
  );
};

export { CustomSorter };